import { mq } from './variables.js';

// slick-slider config
const sliderJs = require('./slick-slider.js');

class GallerySlider {
  constructor() {
    this.gsSlider = document.querySelector("#bildergalerie");

    if (this.gsSlider === null) {
      return false;
    }
    this.slider = this.gsSlider.querySelector(".js-gallery-slider");
    this.gallerySliderWidth = '';
    this.gallerySliderHeight = '';
    this.amountGallerySlides = 0;

    this.setHeight();
  }

  setHeight() {        
    if (mq.mdX.matches) {
      this.amountGallerySlides = 0.235;//0.365;
    } else {
      //console.log(this.gallerySliderWidth + " :: "+ this.gallerySliderHeight);
      this.amountGallerySlides = 0.365;//0.525;
    }
    this.gallerySliderWidth = this.gsSlider.clientWidth;
    this.gallerySliderHeight = Math.ceil(this.gsSlider.clientWidth * this.amountGallerySlides);

    this.slider.style.setProperty("height", this.gallerySliderHeight+'px'); 

    return this.gallerySliderHeight;
  }
}

let gallerSlider = new GallerySlider();

function initGallerySlider() {
  sliderJs.gallerySlider.slick(sliderJs.gallerySliderOptions);
}
function resizeGallerySlider() {
  if (gallerSlider.gsSlider !== null) {
    gallerSlider.setHeight();
  }
}

window.addEventListener('load', (event) => {
  initGallerySlider();
});

window.addEventListener('resize', (event) => {
  resizeGallerySlider();
});
